// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:11:55

export default {
  "id": "cars-derby-arena",
  "slug": "cars-derby-arena",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7db068993ba34a7f8ee8981c000719b8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7db068993ba34a7f8ee8981c000719b8/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cars Derby Arena",
      "description": "Welcome to the world of Car Derby Arena! In this exciting game you can enjoy the unique experience of changing the color of cars, improving their performance, and manipulating gravity and weather conditions. Your goal is to become an invincible master of destruction, pump up your car and crush everything in your path. Embark on exciting missions, compete with other players and prove your skills in this epic Car Derby Arena game!",
      "instructions": "PC control:\nWASD or arrows - drive.\nC - change camera.\nR - repair the car.\nF - nitro acceleration.\nP - pause game.\nSpacebar - handbrake.\nF2 - restart the level.\nG - open and close the gravity panel, slow down time.\nKeys 1 through 9 to switch the level of gravity, as well as the keys 0 and \"-\".",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "arena"
      ]
    },
    "zh-CN": {
      "title": "汽车竞速竞技场",
      "description": "欢迎来到卡德比竞技场的世界！在这款激动人心的游戏中，您可以享受改变汽车颜色、提升性能以及操控重力和天气条件的独特体验。您的目标是成为无敌的破坏大师，升级您的汽车，摧毁一切障碍。踏上激动人心的任务，与其他玩家竞技，在这款史诗般的卡德比竞技场游戏中证明您的技能！",
      "instructions": "PC控制：\nWASD或箭头键 - 驾驶。\nC - 切换摄像头。\nR - 修理汽车。\nF - 使用氮气加速。\nP - 暂停游戏。\n空格键 - 手刹。\nF2 - 重新开始关卡。\nG - 打开和关闭重力面板，减慢时间。\n数字键1至9切换重力等级，以及数字键0和\"-\"。",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "竞技场"
      ]
    },
    "zh-TW": {
      "title": "卡車競速賽場",
      "description": "歡迎進入卡車拉力賽場的世界！在這款刺激的遊戲中，您可以享受更改車輛顏色、提升性能以及操控引力和天氣條件的獨特體驗。您的目標是成為無敵的毀滅大師，給您的車輛充滿能量，擊毀您道路上的一切。啟航於精彩任務，與其他玩家競爭，在這款經典的卡車拉力賽場遊戲中展現您的技巧！",
      "instructions": "PC控制：\nWASD 或箭頭鍵 - 驅動。\nC - 切換相機。\nR -修理車輛。\nF - 硝化加速度。\nP - 暫停遊戲。\n空格鍵 - 手煞車。\nF2 - 重啟關卡。\nG - 開啟和關閉重力面板，減慢時間流速。\n按鍵1至9切換重力等級，以及按鍵0和\"-\"。",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "競技場"
      ]
    },
    "zh-HK": {
      "title": "卡車競速賽場",
      "description": "歡迎進入卡車賽車場的世界！在這款刺激的遊戲中，你可以享受更換車輛顏色、提升性能和操縱重力和天氣條件的獨特體驗。你的目標是成為無敵的毀滅大師，加強你的車輛，壓碎你前方的所有障礙。啟航於精彩的任務，與其他玩家競爭，並在這款經典的卡車賽車場遊戲中證明你的技巧！",
      "instructions": "PC控制：\nWASD 或箭頭鍵 - 驅動。\nC - 更改相機。\nR - 修理車輛。\nF - 經濟加速。\nP - 暫停遊戲。\n空格鍵 - 手煞車。\nF2 - 重啟關卡。\nG - 開啟和關閉重力面板，放慢時間。\n鍵盤1至9鍵切換重力等級，以及鍵盤0和\"-\"鍵。",
      "genres": [
        "賽車及駕駛"
      ],
      "tags": [
        "戰場"
      ]
    },
    "ja": {
      "title": "カーズ・デュービー・アリーナ",
      "description": "カーディアビジョンアリーナの世界へようこそ！この刺激的なゲームでは、車の色を変えたり、パフォーマンスを向上させたり、重力や天候を操作するユニークな体験が楽しめます。あなたの目標は、無敵の破壊の達人になること、車を強化し、道に迷うものすべてを圧倒することです。興味深いミッションに乗り出し、他のプレイヤーと競い合い、この壮大なカーディアビジョンアリーナゲームでのあなたのスキルを証明しましょう！",
      "instructions": "PCコントロール：\nWASDまたは矢印キー - 駆動。\nC - カメラの変更。\nR - 車の修理。\nF - ニトロ加速。\nP - ゲームの一時停止。\nスペースバー - 手ブレーキ。\nF2 - レベルの再始動。\nG - 重力パネルの開閉、時間の減速。\nキー1から9までのキーで重力のレベルを切り替え、キー0および\"-\"も使用可能。",
      "genres": [
        "レーシング＆ドライビング"
      ],
      "tags": [
        "アリーナ"
      ]
    },
    "ko": {
      "title": "카즈 드러비 아레나",
      "description": "카 드러비 아레나의 세계에 오신 것을 환영합니다! 이 흥미진진한 게임에서는 차의 색상을 변경하고 성능을 향상시키며 중력과 기상 조건을 조작할 수 있는 독특한 경험을 즐길 수 있습니다. 목표는 파괴의 불패의 마스터가 되고, 차를 강화하고 길 위의 모든 것을 부수는 것입니다. 흥미진진한 임무에 뛰어들고 다른 플레이어들과 경쟁하고 이 에픽 카 드러비 아레나 게임에서 자신의 기술을 입증하세요!",
      "instructions": "PC 조종:\nWASD 또는 방향키 - 운전.\nC - 카메라 변경.\nR - 차량 수리.\nF - 니트로 가속.\nP - 게임 일시 중지.\n스페이스바 - 핸드브레이크.\nF2 - 레벨 재시작.\nG - 중력 패널 엽니다. 시간을 늦축니다.\n1부터 9까지의 키로 중력 수준을 변경하고, 0과 \"-\" 키도 사용합니다.",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "경장"
      ]
    },
    "fr": {
      "title": "Courses de voitures Arena",
      "description": "Bienvenue dans le monde de Car Derby Arena ! Dans ce jeu passionnant, vous pouvez profiter de l'expérience unique de changements de couleur des voitures, d'amélioration de leur performance, et de manipulation des conditions de gravité et de météo. Votre objectif est de devenir un maître invincible de la destruction, gonfler votre voiture et écraser tout ce qui se trouve sur votre chemin. Engagez-vous dans des missions passionnantes, concurrençez d'autres joueurs et prouvez vos compétences dans ce jeu épique de Car Derby Arena !",
      "instructions": "Contrôle PC :\nWASD ou flèches - conduire.\nC - changer de caméra.\nR - réparer la voiture.\nF - accélération nitro.\nP - mettre en pause le jeu.\nBarre d'espace - frein à main.\nF2 - redémarrer le niveau.\nG - ouvrir et fermer le panneau de gravité, ralentir le temps.\nTouches 1 à 9 pour changer le niveau de gravité, ainsi que les touches 0 et \"-\".",
      "genres": [
        "Course et conduite"
      ],
      "tags": [
        "Arène"
      ]
    }
  }
};
